(function () {
  const ourCommunitySectionId = window.__ourCommunitySectionId;

  function initOurCommunity() {
    var elem = document.querySelector(`.lp-our-community__${ourCommunitySectionId} .main-carousel`);

      if (elem && typeof Flickity !== 'undefined') {
      const isMobile = window.innerWidth < 768;
      
      new Flickity(elem, {
        cellAlign: 'left',
        contain: true,
        wrapAround: isMobile,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.015,
        friction: 0.25,
        draggable: true,
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initOurCommunity();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId !== ourCommunitySectionId) return;
    initOurCommunity();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.detail.sectionId !== ourCommunitySectionId) return;
    var elem = document.querySelector(`.lp-our-community__${ourCommunitySectionId} .main-carousel`);
    if (elem && typeof Flickity !== 'undefined') {
      var flkty = Flickity.data(elem);
      if (flkty) flkty.destroy();
    }
  });
})();